import { useTranslation } from 'react-i18next';
import { MoonIcon } from '../icons/MoonIcon';
import { SunIcon } from '../icons/SunIcon';
import { classes } from '../layout/space';
import './DayNightToggle.css';

type Mode = 'light' | 'dark';
export function DayNightToggle({ value, onChange, className, compact = false }: {
  value: Mode;
  onChange: (value: Mode) => void;
  className?: string;
  compact?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className={classes('day-night-toggle', compact && 'day-night-toggle--compact', className)}
      role="group" aria-label={t('newBox.appearance.previewMode')}>
      {(['dark', 'light'] as const).map(mode => (
        <button key={mode} type="button" aria-label={t(`newBox.appearance.${mode}`)}
          aria-pressed={value === mode} onClick={() => onChange(mode)}>
          {mode === 'dark' ? <MoonIcon /> : <SunIcon />}
          <span className="day-night-toggle__label">{t(`newBox.appearance.${mode}`)}</span>
        </button>
      ))}
    </div>
  );
}
